import { Client } from "@stomp/stompjs";
import eventBus from "./eventBus";

const config = {
  staging: {
    RABBIT_URL: "wss://mq-staging.riders.ai/ws",
    RABBITMQ_READ_USER: "ridersui",
    RABBITMQ_READ_PASSWORD: "ridersui",
  },
  production: {
    RABBIT_URL: "wss://mq.riders.ai/ws",
    RABBITMQ_READ_USER: "ridersui",
    RABBITMQ_READ_PASSWORD: "ridersui",
  },
};

const environment = window.location.hostname.includes(
  "editor-staging.riders.ai"
)
  ? "staging"
  : "production";

const socket = (session: string) => {
  const client = new Client({
    brokerURL: config[environment].RABBIT_URL,
    connectHeaders: {
      login: config[environment].RABBITMQ_READ_USER,
      passcode: config[environment].RABBITMQ_READ_PASSWORD,
    },
    reconnectDelay: 30000,
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
  });

  client.onConnect = (frame) => {
    client.subscribe(`/amq/queue/events-session-${session}`, (data) => {
      eventBus.dispatch("event-received", JSON.parse(data.body));
    });
  };

  client.onStompError = (frame) => {
    console.log("Broker reported error: " + frame.headers["message"]);
    console.log("Additional details: " + frame.body);
  };

  client.activate();
};

export default socket;
